module.exports = __webpack_public_path__ + "static/media/ZenMLB.9224e4ee.jpg";